import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Dialog } from '@radix-ui/themes';
import { Rating as Stars } from '@mui/material';

import { RatingsList } from './RatingsList.jsx';
import { useReportsRating } from '../data';
import styles from './RatingStatCard.module.css';

export const RatingStatCard = ({ campaignId }) => {
  const { t } = useTranslation('reports');
  const [dialogOpen, setDialogOpen] = useState(false);

  const {
    averageRating,
    totalResponses,
    showRating,
    isLoading,
  } = useReportsRating({
    campaignId,
  });

  if (!showRating) return null;

  return (
    <>
      <Tooltip content={t('summary.statCards.ratingTooltip')}>
        <button
          type="button"
          className={styles.card}
          onClick={() => setDialogOpen(true)}
        >
          <div className={styles.header}>
            <div className={styles.labelGroup}>
              <i className={`fa-regular fa-star ${styles.icon}`} />
              <p className={styles.label}>{t('summary.statCards.rating')}</p>
            </div>
          </div>
          {isLoading ? (
            <div className={styles.ratingRow}>
              <i
                className="fa-solid fa-spinner fa-spin"
                style={{ fontSize: 24, color: 'var(--gray-8)' }}
              />
            </div>
          ) : (
            <>
              <div className={styles.ratingRow}>
                <Stars
                  precision={0.1}
                  value={averageRating}
                  size="small"
                  readOnly
                  sx={{
                    '& .MuiRating-iconFilled': {
                      color: 'var(--amber-9)',
                    },
                    '& .MuiRating-iconEmpty': {
                      color: 'var(--gray-6)',
                    },
                  }}
                />
                <span className={styles.value}>
                  {(averageRating || 0).toFixed(1)}
                </span>
              </div>
              <p className={styles.description}>
                {t('summary.statCards.ratingDesc', { count: totalResponses })}
              </p>
            </>
          )}
        </button>
      </Tooltip>

      <Dialog.Root open={dialogOpen} onOpenChange={setDialogOpen}>
        <Dialog.Content style={{ maxWidth: 900 }}>
          <RatingsList
            campaignId={campaignId}
            onClose={() => setDialogOpen(false)}
          />
        </Dialog.Content>
      </Dialog.Root>
    </>
  );
};
